import PropTypes from 'prop-types'
import Stack from '@mui/material/Stack'

const MODAL_SIZES = {
  auto: 'auto',
  xs: '150px',
  sm: '325px',
  md: '430px',
  lg: '500px',
  xl: '600px',
  xxl: '765px',
  xxxl: '1000px',
}

const ModalView = ({
  sizeX,
  allowOverflow,
  children,
  ...props
}) => {
  const {
    sx = {},
    ...otherProps
  } = props

  return (
    <Stack
      className="modal-view"
      width={MODAL_SIZES[sizeX]}
      maxWidth="100%"
      maxHeight="calc(100vh - 120px)"
      sx={{
        overflowX: allowOverflow ? undefined : 'hidden',
        overflowY: allowOverflow ? undefined : 'auto',
        ...sx
      }}
      {...otherProps}
    >
      {children}
    </Stack>
)
}

ModalView.propTypes = {
  sizeX: PropTypes.oneOf(Object.keys(MODAL_SIZES)),
  allowOverflow: PropTypes.bool,
}

ModalView.defaultProps = {
  sizeX: 'sm',
}

export default ModalView
